import { store } from '@/store/store'
import router from '@/router'
import Vue from 'vue'

export function temAcesso(regra) {
    if (!store.getters.estaAutenticado) {
        store.dispatch('tryAutoLogin')
        if (!store.getters.estaAutenticado) {
            router.push('/login')
            return false
        }
    }
    let decodedToken = Vue.$jwt.decode(store.getters.getToken)
    let regrasEncoded = decodedToken.usrRegras
    let regras = atob(regrasEncoded)
    if (typeof regra === 'object') {
        if (regra.length > 0) {
            if (
                regra.every(item => {
                    return regras.indexOf(item) === -1
                })
            ) {
                return false
            }
        }
        return true
    } else {
        if (regra) {
            if (regras.indexOf(regra) === -1) {
                return false
            }
        }
        return true
    }
}

export function temAcessoView(regra) {
    if (!store.getters.estaAutenticado) {
        store.dispatch('tryAutoLogin')
        if (!store.getters.estaAutenticado) {
            return false
        }
    }
    let decodedToken = Vue.$jwt.decode(store.getters.getToken)
    let regrasEncoded = decodedToken.usrRegras
    let regras = atob(regrasEncoded)
    if (typeof regra === 'object') {
        if (regra.length > 0) {
            if (
                regra.every(item => {
                    return regras.indexOf(item) === -1
                })
            ) {
                return false
            }
        }
        return true
    } else {
        if (regra) {
            if (regras.indexOf(regra) === -1) {
                return false
            }
        }
        return true
    }
}

export function authNav(navItens) {
    let authNavItens = []
    for (let i = 0; i < navItens.length; i++) {
        if (navItens[i].regras) {
            if (temAcessoView(navItens[i].regras)) {
                let navTempItem = navItens[i]
                if (navItens[i].children) {
                    if (navItens[i].children.length > 0) {
                        navTempItem.children = authNav(navItens[i].children)
                    }
                }
                authNavItens.push(navTempItem)
            }
        } else {
            authNavItens.push(navItens[i])
        }
    }
    return authNavItens
}
